import { z } from 'zod'

import type {
  CommonResponseListConceptResponse,
  ConceptResponse,
  GetSubTopicsData,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import { type Concept, ConceptSchema, type ConceptTopic, ConceptTopicSchema } from './schemas'

export const adaptConcept = (raw: ConceptResponse): Concept =>
  parseApiResponse(ConceptSchema, raw, 'Concept')

export const adaptConcepts = (raw: CommonResponseListConceptResponse['data']): Concept[] =>
  parseApiResponse(z.array(ConceptSchema), raw, 'Concept')

// 스펙이 SubTopicResponse.repProblemImageUrl 의 nullable 을 optional 로만 그린다. 서버는 `String?` 으로 선언하고
// null 을 직렬화한다. 2026-10-07 백엔드 develop 의 concept/controller/response/SubTopicResponse.kt 로 확인.
// 백엔드가 nullable 을 스펙에 싣으면 이 캐스트와 주석만 지운다.
const asWire = (raw: GetSubTopicsData): unknown => raw

export const adaptConceptTopics = (raw: GetSubTopicsData): ConceptTopic[] =>
  parseApiResponse(z.array(ConceptTopicSchema), asWire(raw), 'ConceptTopic')
